<template>
    <button @click="nextPage()" v-if="current_page < total_pages" :class="classes">
        <slot></slot>
    </button>
</template>
<script>
  import DataGridLoadMore from 'js/theme-mixins/DataGridLoadMore';

  export default {
    mixins: [DataGridLoadMore],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/assets/js/theme-components/grid/DataGridLoadMore.vue